export class BirthDayDismissList {
   id: number
   SavedTimeSlotId: number
   SaveTimeEndSlotId: number
   CallStatus: number

   constructor() {
      this.id = null
      this.SavedTimeSlotId = null
      this.SaveTimeEndSlotId = null
      this.CallStatus = null;
   }

}